import * as FormRecord from "./form-record.ts";
import * as FormUtil from "../common/form-util.ts";
import * as Chats from "./chats.ts";
import * as Layout from "../layout/layout.ts";

import * as Searchbar from "../components/searchbar.ts";
import * as LoadingDialog from "../components/loading-dialog.ts";

import SimpleBar from "simplebar";
import ResizeObserver from "resize-observer-polyfill";

export interface PagesGlobalScope {
  Pages: {
    FormRecord: typeof FormRecord;
    Chats: typeof Chats;
  };
}

export interface SimpleBarGlobalScope {
  SimpleBar: {
    SimpleBar: typeof SimpleBar;
    ResizeObserver: typeof ResizeObserver;
  };
}

export interface LayoutGlobalScope {
  Layout: typeof Layout;
}

export interface ComponentsGlobalScope {
  Components: {
    Searchbar: typeof Searchbar;
    LoadingDialog: typeof LoadingDialog;
  };
}

export interface FormUtilGlobalScope {
  FormUtil: typeof FormUtil;
}

/**
 * Create an object with properties that should be available in the global scope. These
 * are usually used by XHTML pages.
 * @returns Properties to add to global user portal scope.
 */
export function createGlobalPagesExports(): PagesGlobalScope {
  return {
    Pages: {
      FormRecord,
      Chats,
    },
  };
}

export function createGlobalSimplebarExports(): SimpleBarGlobalScope {
  return {
    SimpleBar: {
      SimpleBar,
      ResizeObserver,
    },
  };
}

export function createGlobalLayoutExports(): LayoutGlobalScope {
  return {
    Layout,
  };
}

export function createGlobalComponentsExports(): ComponentsGlobalScope {
  return {
    Components: {
      Searchbar,
      LoadingDialog,
    },
  };
}

export function createFormUtilExports(): FormUtilGlobalScope {
  return {
    FormUtil,
  };
}
